import axios from 'axios';
import { obtenerSesion, cerrarSesion } from './sesion';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:4001',
});

api.interceptors.request.use((config) => {
  const sesion = obtenerSesion();
  if (sesion?.token) {
    config.headers.Authorization = `Bearer ${sesion.token}`;
  }
  return config;
});

api.interceptors.response.use(
  (respuesta) => respuesta,
  (error) => {
    if (error.response?.status === 401) {
      cerrarSesion();
      if (window.location.pathname !== '/login') {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;
